import React from 'react'

import { H3 } from '@mxenabled/mxui'

import { CardHeader as MuiCardHeader, SxProps, Theme } from '@mui/material'

export interface CardHeaderProps {
  menuActionElement?: React.ReactNode
  hasFullWidthImage?: boolean
  isMini?: boolean
  subHeader?: React.ReactNode
  sx?: SxProps<Theme>
  title: string
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  menuActionElement = null,
  hasFullWidthImage = false,
  isMini = false,
  subHeader,
  sx = {},
  title,
}) => {
  return (
    <MuiCardHeader
      action={menuActionElement}
      subheader={subHeader}
      sx={{
        alignItems: 'flex-start',
        p: 0,
        mb: 16,
        ...(hasFullWidthImage && { ...(isMini ? { mb: 16 } : { px: 16, pt: 16, mb: 0 }) }),
        ...sx,
      }}
      title={
        <H3
          dangerouslySetInnerHTML={{ __html: title }}
          sx={isMini ? { letterSpacing: 0.35 } : {}}
        />
      }
    />
  )
}
